<template>
    <div>
        <div class="text-center" v-if="vertical">
            <div v-if="handler">
                <a href="#" @click.prevent="handler()" class="avatar rounded-circle">
                    <img :src="user.avatar">
                </a>
                <h4 class="mb-0">
                    <a href="#" @click.prevent="handler()">{{ user.name }}</a>
                </h4>
                <small v-if="subtitleText" v-html="subtitleText"></small>
            </div>
            <div v-else>
                <span class="avatar rounded-circle">
                    <img :src="user.avatar">
                </span>
                <h4 class="mb-0">{{ user.name }}</h4>
                <small v-if="subtitleText" v-html="subtitleText"></small>
            </div>
        </div>

        <div class="row text-left align-items-center" v-if="!vertical && handler">
            <div class="col-auto pr-0">
                <a href="#" @click.prevent="handler()" class="avatar rounded-circle">
                    <img :src="user.avatar">
                </a>
            </div>
            <div class="col">
                <h4 class="mb-0">
                    <a href="#" @click.prevent="handler()">{{ user.name }}</a>
                </h4>
                <small v-if="subtitleText" v-html="subtitleText"></small>
            </div>
        </div>

        <div class="row text-left align-items-center" v-if="!vertical && !handler">
            <div class="col-auto pr-0 avatar rounded-circle">
                <img :src="user.avatar">
            </div>
            <div class="col">
                <h4 class="mb-0">{{ user.name }}</h4>
                <small v-if="subtitleText" v-html="subtitleText"></small>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            user: {
                type: Object,
                required: true
            },

            handler: {
                type: Function,
                default: null
            },

            vertical: {
                type: Boolean,
                default: false
            },

            subtitle: {
                type: String,
                default: null
            },
        },

        computed: {

            subtitleText() {
                if (this.subtitle) {
                    return this.subtitle
                }
                return null
            }
        }
    }
</script>
